import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'color-box',
  templateUrl: './color-box.component.html',
  styleUrls: ['./color-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorBoxComponent implements OnInit {

  @Input()
  text;
  @Input()
  config;

  color = '#363636';

  constructor() { }

  ngOnInit() {
    if (!this.text) {
      return;
    }
    for (let i = 0; i < this.config.segments.length; i++) {
      if (this.text === this.config.segments[i].text) {
        this.color = this.config.segments[i].color;
        break;
      }
    }
    this.text = this.config.prefix + this.text;
  }
}
